import { render, staticRenderFns } from "./cprs-additional-cards.component.vue?vue&type=template&id=700930ee"
import script from "./cprs-additional-cards.component.ts?vue&type=script&lang=ts&external"
export * from "./cprs-additional-cards.component.ts?vue&type=script&lang=ts&external"
import style0 from "./cprs-additional-cards.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports